import comp from "./AcademicRecordsWrapper";
export default comp;
